import { render, staticRenderFns } from "./map1.vue?vue&type=template&id=1220e931&scoped=true"
import script from "./map1.vue?vue&type=script&lang=js"
export * from "./map1.vue?vue&type=script&lang=js"
import style0 from "./map1.vue?vue&type=style&index=0&id=1220e931&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220e931",
  null
  
)

export default component.exports